
































































































import { Component, Vue, Watch } from "vue-property-decorator";
import indexService from "../../service/indexService";
import KScroll from '../../components/k-scroll.vue';
import utils from '../../utils';

@Component({
  components: { KScroll }
})
export default class About extends Vue {
  private scrollHheight: number = 115;
  private newHeight: number = 300;
  private type: any = "#base1";
  private newsList: any[] = [];
  private obj: any = null;


  private callbacks(obj: any) {
    this.obj = obj;
  }

  private created() {
    // 新闻媒体
    indexService.getNewsList(100).then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        for (const item of result.list) {
          item.create = this.changeTime(item.create);
          if (item.title && item.title.length > 46) {
            item.title = utils.isSubstring(item.title, 46) + '...';
          }
        }
        this.newsList = result.list;
        // const ht = 117 * Math.round(this.newsList.length / 2);
        // if (  ht > 585 ) {
        //     (this.$refs.verticalList as HTMLDivElement).style.height = 595 + 'px';
        // } else {
        //     (this.$refs.verticalList as HTMLDivElement).style.height = (ht + 20) + 'px';
        // }
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });

  }

  private change(a: string) {
    this.type = a;
  }

  private changeTime(time: string) {
    const str = time.split(' ')[0].split('-');
    return str[0] + '年' + str[1] + '月' + str[2] + '日';
  }

}
